
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/betingelser",
      function () {
        return require("private-next-pages/betingelser/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/betingelser"])
      });
    }
  